import axios from 'axios';

export default {
    create(data) {
        var options = {
            url: window.apiUrl + '/final-project',
            method: 'POST',
            data:data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    get(term) {
        
        let url = window.apiUrl + '/final-projects';
        
        if (term) url += '?term=' + term;

        var options = {
            url: url,
            method: 'GET',
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },

    convertToGallery(project) {
        const data = {
            project: project,
        }

        const options = {
            method: 'POST',
            url: window.apiUrl + '/project-to-gallery',
            data: data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    
    createFeedback(data) {
        var options = {
            url: window.apiUrl + '/final-feedback',
            method: 'POST',
            data:data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    updateFeedback(data) {
        var options = {
            url: window.apiUrl + '/final-feedback',
            method: 'PATCH',
            data:data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    deleteFeedback(id) {
        var options = {
            url: window.apiUrl + '/final-feedback/' + id,
            method: 'DELETE',           
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/final-projects/index.js